'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _loginCookieUtils = require('../../helpers/loginCookieUtils');

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import styles from '../styles/facebook.scss';

var javaScriptInitilized = false;
// zdroj: https://developers.facebook.com/docs/facebook-login/web/login-button
// inspired by https://github.com/keppelen/react-facebook-login/blob/master/src/facebook.js
var FacebookLogin = (_dec = (0, _reactRedux.connect)(function (state) {
  return { authState: state.auth };
}, authActions), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FacebookLogin, _React$Component);

  function FacebookLogin(props) {
    (0, _classCallCheck3.default)(this, FacebookLogin);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FacebookLogin.__proto__ || (0, _getPrototypeOf2.default)(FacebookLogin)).call(this, props));

    _this.componentDidMount = function () {
      if (javaScriptInitilized) return;
      javaScriptInitilized = true;

      // Musime vytvorit trvaly root element: nesmi se prerendrovat: <div id="fb-root"></div>
      var fbRoot = document.createElement('div');
      fbRoot.id = 'fb-root';
      document.body.appendChild(fbRoot);

      window.fbAsyncInit = function () {
        // console.log('inicializuju FB Login');
        FB.init({ // eslint-disable-line
          appId: _this.props.appId,
          xfbml: _this.props.xfbml,
          version: 'v' + _this.props.version
        });
        if (!window.agamaLogins) window.agamaLogins = {};

        window.agamaLogins.facebook = function (cb) {
          var onFbResponse = function onFbResponse(response) {
            if (response.authResponse) {
              var idToken = window.FB.getAccessToken();
              if (cb) cb(idToken);else _this.props.login(idToken, 'facebook');
            }
          };
          FB.login(onFbResponse, { scope: _this.props.scope }); // eslint-disable-line          
        };

        var cookieServiceName = (0, _loginCookieUtils.getServiceName)();
        var prihlasitAutomaticky = cookieServiceName === 'facebook';
        if (prihlasitAutomaticky) {
          // viz toto: https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus
          // FB.getLoginStatus(this.checkLoginState);  // eslint-disable-line //todo: dodelat pomoc facebook api
          _this.onBtnClick();
        }
      };

      // Load the SDK asynchronously
      var createScriptElement = function createScriptElement(d, s, id) {
        // eslint-disable-line
        var element = d.getElementsByTagName(s)[0];
        var fjs = element;
        var js = element;
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        // js.onload = cb;
        fjs.parentNode.insertBefore(js, fjs);
      };
      createScriptElement(document, 'script', 'facebook-jssdk');
    };

    _this.onBtnClick = function (event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      window.agamaLogins.facebook();
      return true;
    };

    _this.render = function () {
      var styles = require('./LoginMenu.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          { className: styles.btnLogin + ' ' + styles.btnFacebook,
            onClick: _this.onBtnClick
          },
          _this.props.textButton
        )
      );
    };

    return _this;
  }

  // startsLogin = (idToken) => {
  //   this.props.login(idToken, 'facebook');
  // }

  // responseApi = (authResponse) => {
  //   // zavolám moje api
  //   console.log('aa');
  //   const signedIdToken = window.FB.getAuthResponse().signedRequest;
  //   console.log('bb');
  //   const idToken = window.FB.getAccessToken();
  //   console.log(idToken);
  //   console.log('adresa pro serverove ziskani udaju je je');
  //   console.log('https://graph.facebook.com/v2.3/me?access_token=' + idToken + '&fields=name%2C%20email%2C%20locale%2C%20picture%2C%20timezone&method=get&pretty=1');
  //   console.log('adresa pro serverove ziskani aplikace, pro kterou byl token vydan je (casem take vyprsi, coz je dobre): ');
  //   console.log('https://graph.facebook.com/app?access_token=' + idToken);
  //   console.log('adresa pro serverove overeni tokenu je ');
  //   console.log('https://graph.facebook.com/debug_token?input_token=' + idToken + '&access_token=' + 'TOKENAPLIKACE');

  //   // nasledujic neni treba
  //   console.log('cc');
  //   window.FB.api('/me', { fields: this.props.fields }, (me) => {
  //     console.log('dd');
  //     me.accessToken = authResponse.accessToken;
  //     console.log(me);
  //     console.log(signedIdToken);
  //     console.log(idToken);

  //     // na serveru dekodovat idToken
  //     // this.props.callback(me);
  //     // zabalit pomocí NPM jwt-simple
  //     // https://graph.facebook.com/app/?access_token=CAADN23nBGHUBAIItKb7lPuM43RB5ElOozvZBMirXCnGd0ZChIbduZCeE0epnvR6g2GksBMUI6Cu7iDlq7ZAnpzStVkmNKGEhD13ttBFR3eUwwmVPgV3o5sHhdX3Nl8khUqk7vBM9t0kfKgfQ00skBGVE02OmxlQpaoGTpZBCbkHIHZCqyZCB936h1PqMPA9s0BE2fIpMgdjRwZDZD
  //   });
  // };

  // <div id="fb-root"></div>

  return FacebookLogin;
}(_react2.default.Component), _class2.propTypes = {
  // callback: PropTypes.func,
  appId: _react.PropTypes.string.isRequired,
  xfbml: _react.PropTypes.bool,
  scope: _react.PropTypes.string,
  textButton: _react.PropTypes.string,
  size: _react.PropTypes.string,
  fields: _react.PropTypes.string,
  cssClass: _react.PropTypes.string,
  version: _react.PropTypes.string,
  icon: _react.PropTypes.string,
  login: _react.PropTypes.func
}, _class2.defaultProps = {
  textButton: 'Login with Facebook',
  scope: 'public_profile, email',
  xfbml: false,
  size: 'medium',
  fields: 'name, email, locale, picture',
  cssClass: 'kep-login-facebook kep-login-facebook-',
  version: '2.3'
}, _temp)) || _class);
exports.default = FacebookLogin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Logins/FacebookLogin.js
// module id = 1181
// module chunks = 0